<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">待完成疫苗驱虫列表</div>
				<div class="titleR">
					
				</div>
			</div>
			<div class="content">
				<div class="con">
					<!-- <div class="tabLine">
						<div class="tabLineL">
							
						</div>
						<div class="tabLineR">
							
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							
						</div>
						<div class="searchLineR"></div>
					</div> -->
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" min-width="50">
								<template slot-scope="props">
									<span>{{props.row.id}}</span>
									<span v-if="props.row.oneSelf" style="color:rgb(253, 78, 78)">(自用)</span>
								</template>
							</el-table-column>
							<el-table-column label="类型" min-width="50">
								<template slot-scope="props">
									<span v-if="props.row.serviceTypeId===1">疫苗</span>
									<span v-if="props.row.serviceTypeId===2">驱虫</span>
								</template>
							</el-table-column>
							<el-table-column label="套餐名称" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.servicePackageName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="顾客" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="手机号" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberMobile}}</div>
								</template>
							</el-table-column>
							<el-table-column label="宠物" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.petName}} </div>
								</template>
							</el-table-column>
							<el-table-column label="品种" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.typeName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="下次计划时间" min-width="50">
								<template slot-scope="props">
									<div v-if="props.row.payType===2" style="color:#BB6508">
										{{$public.FTime(props.row.planNextDate,'YYYY-MM-DD')}}<br>{{props.row.serviceStatus===2?'已失效':''}}
									</div>
									<div v-else>
										{{$public.FTime(props.row.planNextDate,'YYYY-MM-DD')}}<br>{{props.row.serviceStatus===2?'已失效':''}}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="完成情况" min-width="50">
								<template slot-scope="props">
									<span style="color:#18A44C">{{props.row.completeCount}}</span>/<span>{{props.row.planCount}}</span>
								</template>
							</el-table-column>
							<el-table-column label="创建门店" min-width="50">
								<template slot-scope="props">
									<span>{{$public.getShopNameById(props.row.shopId)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" min-width="50">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="see_ymqc(props.row)">查看</el-button>
									<el-button v-show="$buttonAuthority('yewu-yiliaoxin-editquchong')" type="text" @click="edit_ymqc(props.row)" size="mini">编辑</el-button>
									<el-button v-show="$buttonAuthority('yewu-yiliaoxin-delquchong')" type="text" @click="del_ymqc(props.row)" size="mini">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			loginInfo(){
				return this.$store.state.userInfo
			},
			rightYmqcParams(){
				return this.$store.state.yiliaoxin.rightYmqcParams
			}
		},
		created(){
			
		},
		mounted(){
			this.page = this.rightYmqcParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			see_ymqc(row){
				let obj = this.$store.state.yiliaoxin.ymqcParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_ymqcParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'疫苗驱虫')
				this.$store.commit("yiliaoxin/add_router",{name:'疫苗驱虫',data:obj})
			},
			edit_ymqc(row){
				let obj = this.$store.state.yiliaoxin.ymqcParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_ymqcParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'疫苗驱虫')
				this.$store.commit("yiliaoxin/add_router",{name:'疫苗驱虫',data:obj})
			},
			del_ymqc(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/MedicalPackage/Delete', {serviceId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"serviceTypeId": 0,  // 0全部 1疫苗；2驱虫;
					"payType": -1,   // -1 1全额支付；2计划支付 3套餐卡
					isPay:-1,            // -1全部 0未支付 1已支付
					isComplete:0,                    //-1全部；0待完成；1已完成
					serviceStatus:-1,                    //-1全部；1正常；2失效
					createUserId:this.loginInfo.uid,
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					shopId:this.$store.state.shopId,
					"keyword": '',
				}
				this.$http.post('/api/MedicalPackage/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.rightYmqcParams.initialDataOflist = {
					page:JSON.parse(JSON.stringify(this.page)),
				}
				this.$store.commit("yiliaoxin/set_rightYmqcParams",JSON.parse(JSON.stringify(this.rightYmqcParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'rYmqc',data:JSON.parse(JSON.stringify(this.rightYmqcParams))})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
